import { render, staticRenderFns } from "./trainingsTableSkeleton.vue?vue&type=template&id=5e0d6c8a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports